<pop-error-wrapper>
  <h1 title
      translate="ERROR.LICENSE_EXPIRED_SHORT"></h1>
  <p description
     translate="ERROR.LICENSE_EXPIRED"></p>
</pop-error-wrapper>
